// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"524":"app","884":"admin"}[chunkId] || chunkId) + "." + {"207":"027c82378ec43036a205","345":"d43a6ec81e77264d5494","524":"c82cea0d8a6a954a879b","532":"48056d57d45cf5700e4f","671":"bba5e4ea448c8907f75e","708":"57be1c1794147b88065a","884":"6b0eef6bd9d17ddc3d65","912":"1a6fdcf4a5e5fa825ed0"}[chunkId] + ".js";
};